import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ih4abkp: FaireProductEntity = {
  token: "p_8ih4abkp",
  type: "product",
  name: "Castile Soap 16 oz",
  brandToken: "b_1kcui4ks",
  brandName: "MamaSuds | Non-toxic Household Cleaners + Real Soap",
  imageUrl:
    "https://cdn.faire.com/fastly/942ade6edfb126b12bc0dfb41422230f382f5c4839f13465385cb5f5a0cd91ab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3346464721a77c98fc77e465f221413cfdb9127b24763d431696456f8451cb30.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/61be5106100f8480ba0fe47227671c4dfbd1b4453a0d08ccff0bea1b0c5dc543/1551153165.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ed1662c92464d7a8bf3f34cae41c99eb5479e118bfe0b4b6ccaebb8592ef0ea3/1540298335.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ec2a29d87a53ec4892c9cf790fbbf4a63110997bf568bbb0a01a6c8801c64a1e/1528341494.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b7e65affd6374d7b6c78cc4f9035d78b6df8f3dfab3a955205637f7e562df76b/1528341494.png",
    "https://cdn.faire.com/fastly/df5b03858fdd88cef6944894fb6fcc42a11d31df5ffe6bbc7da513a4d57a6564.png",
    "https://cdn.faire.com/fastly/4d9929a236f1e13e3755e62d0098c0d82af9cbe632f80e31cbef58f71a51d183.png",
  ],
  priceDollars: 5.5,
  description:
    "Having a different cleaner for each room in your home is unnecessary and wasteful. MamaSuds Castile Soap is an incredibly versatile all-purpose cleaning soap. It has hundreds of uses but we especially love it for bathing, face cleansing, hand-washing, floors, dishes, counters, and toilets.\n16  floz\n•INGREDIENTS:  distilled  water,  saponified olive  oil (potassium olivate)\n•Scents:  unscented,  lavender,  lemon.",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:16.261Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
